import { FilterList } from "@/types/filters.type";
import isEmpty from "lodash/isEmpty";
import { getSearchByField } from "@/modules/finance/helper/search-filter-data";
import { useEffect } from "react";

export const useSearchFields = (
  searchString: string,
  conditions: FilterList,
  setValue: (newValue: Partial<Record<string, string>> | undefined) => void,
) => {
  useEffect(
    function syncSearchFieldValue() {
      if (isEmpty(conditions)) {
        return;
      }
      const newSearchField = getSearchByField(conditions, searchString);
      setValue(newSearchField);
    },
    [searchString, conditions, setValue],
  );
};
